<template>
  <div>
    <a-layout style="background-color: white">

      <a-breadcrumb style="padding: 16px 24px">
        <a-breadcrumb-item>
          <router-link :to="{name:'scf'}">
            <a-icon type="home"/>
            <span>首页</span>
          </router-link>
        </a-breadcrumb-item>
        <a-breadcrumb-item href="">
          <router-link :to="{name:'dynamic'}">
            <span>活动动态</span>
          </router-link>
        </a-breadcrumb-item>
      </a-breadcrumb>

      <a-layout-content>
        <div :style="{ padding: '24px',paddingTop:0, background: '#fff', minHeight: '360px' }">

          <a-list item-layout="vertical" :data-source="dynamics">
            <a-list-item slot="renderItem" key="item.title" slot-scope="item, index">

              <a-list-item-meta>
                <a slot="title" class="text-title">{{ item.name }}</a>
              </a-list-item-meta>
              <div style="max-height:60px;" class="overflow-ellipsis"> {{ item.brief }}</div>
              <template>
                <div style="margin-top:12px; text-align: right">
                  <router-link :to="{name:'dynamicInfo', params:{id:item.id}}"
                               style="color:var(--primaryColor); margin:20px 20px 0 0;">查看详情
                    <a-icon type="double-right"></a-icon>
                  </router-link>
                </div>
              </template>

            </a-list-item>
          </a-list>

          <div>


            <a-pagination
              show-quick-jumper
              :default-current="page"
              :total="count"
              :page-size="3"
              :show-total="total => `共 ${total} 条`"
              show-less-items
              @change="pageChange"
            />
          </div>


        </div>
      </a-layout-content>

    </a-layout>


  </div>
</template>

<script>


import {getDynamicList} from "../../api/api";
import {filterUnderLine} from "../../../static/js/util";

export default {
  name: "Dynamic",
  data() {
    return {
      dynamics: [],
      page: 1,
      search: '',
      count: 0

    };
  },
  mounted() {

    this.toGeDynamics()

  },
  methods: {
    pageChange(pageNumber) {
      this.page = pageNumber
      this.toGetActivities(this.page, this.search)
    },
    toGeDynamics(page, search) {
      getDynamicList({page: page, search: search})
        .then(res => {
          this.dynamics = filterUnderLine(res.data.results)
          this.count = res.data.count

        }).catch((err) => {
        console.log(err)
      })
    },
    onCollapse(collapsed, type) {
    },
    onBreakpoint(broken) {
    }
  },
}
</script>

<style scoped>


</style>



// WEBPACK FOOTER //
// src/components/content/Dynamic.vue